import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';

const MetricsCard = ({ title, children, className = '' }) => {
  const { semantic } = useColors();
  
  return (
    <div className={`${semantic.contentCardBg} ${semantic.contentCardBorder} p-6 rounded-lg ${className}`}>
      <h3 className={`text-xl font-semibold ${semantic.contentCardHeading} mb-2`}>{title}</h3>
      <div className="space-y-2">
        {children}
      </div>
    </div>
  );
};

MetricsCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default MetricsCard;

